export default __webpack_public_path__ + "static/14-ce63986f195bdda73a125b52d9a2c109.jpg";